




























import { Component, Vue, Prop } from 'vue-property-decorator'
import { toDate, parseISO, isToday, format } from 'date-fns'
import SocialBookmarks from '../widgets/SocialBookmarks.vue'
import { Page as PageObject } from '~base/common/types'

@Component({
  components: {
    SocialBookmarks,
  },
})
export default class Page extends Vue {
  @Prop({ type: Object, required: true }) readonly page!: PageObject
  private sentToPiano: boolean = false

  mounted() {
    window.scrollTo(0, 0)
    if (this.page.showPaywall && !this.sentToPiano) {
      this.$store.dispatch('paywall/executeExperience', this.page)
      this.sentToPiano = true
    }

    this.$nextTick(() => {
      if (this.hasIframe && process.browser) {
        document
          .querySelector('iframe')!
          .addEventListener('load', () => window.scrollTo(0, 0))
      }
    })
  }

  get timeForHumans() {
    const articleTs = toDate(parseISO(`${this.page.dateGmt}+0`))
    if (isToday(articleTs)) {
      return format(articleTs, this.$t('dates.nice').toString())
    }
    return format(articleTs, this.$t('dates.format').toString())
  }

  get permalink() {
    return `${this.$config.publicUrl}/${this.page.slug}`
  }

  get inPreviewContext() {
    return this.$store.getters['news/inPreviewContext']
  }

  get hasIframe() {
    return this.page.content.match(/<iframe/)
  }

  get showInternalForm() {
    return (
      !this.inPreviewContext && this.$store.getters['paywall/showInternalForm']
    )
  }
}
